import { getCreditCardDetailsById } from '@nemuru-eng/js-api-client';
import { useEffect, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';

import { findCreditCardOnboardingDetailsByRole } from '@/components/widgets/ParticipantSourceWidget/_shared/utils/findCreditCardOnboardingDetailsByRole';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';

export const CreditCardPageManager = () => {
  const {
    state: { loading, applicationParticipant },
    actions: pageActions,
  } = usePageContext();

  const { creditCardId } = useParams();

  if (!creditCardId) return null;

  const { data: creditCardDetails, loading: getCreditCardDetailsByIdLoading } = useCache(
    getCreditCardDetailsById,
    { id: creditCardId },
    { fallbackData: null },
  );

  useEffect(() => {
    if (creditCardDetails === null && getCreditCardDetailsByIdLoading === false) {
      pageActions.setNotFound(true);
    }
  }, [getCreditCardDetailsByIdLoading]);

  useSetPageLoadingWhenRequesting('CREDIT_CARD_DETAILS', [getCreditCardDetailsByIdLoading]);

  const participantOnBoardingDetails =
    creditCardDetails &&
    findCreditCardOnboardingDetailsByRole({
      creditCard: creditCardDetails,
      role: applicationParticipant.role,
    });

  const participantFirstName = participantOnBoardingDetails?.onboardingDetails.invitation.fullName.firstName;
  const participantLastName = participantOnBoardingDetails?.onboardingDetails.invitation.fullName.lastName;
  const title = creditCardDetails ? `${participantFirstName} ${participantLastName} ` : '';
  const subtitle = applicationParticipant.role;

  useLayoutEffect(() => {
    pageActions.setCustomTitle(title);
    pageActions.setCustomSubtitle(subtitle);
  }, [title, subtitle, loading]);

  return <> </>;
};
